import React from 'react';

import { Icon } from '../../../../components';
import { Frame, Img, Slash } from './MascotAvatar.styles';

export type MascotAvatarProps = {
  /** The mascot's first image; left out, a placeholder figure shows. */
  url?: string;
  /** Diameter in px (an `ART_STYLE.MASCOT_*_AVATAR_PX` token). */
  size: number;
  /** "No character": a muted, struck-through placeholder. */
  muted?: boolean;
  className?: string;
};

/**
 * A mascot's avatar: a round crop of its first image (no generated avatar), or a placeholder figure while it has
 * none. Decorative: the name always sits beside it.
 */
export const MascotAvatar = ({ url, size, muted = false, className }: MascotAvatarProps): React.ReactElement => (
  <Frame className={className} $size={size} $muted={muted} aria-hidden="true">
    {url && !muted ? (
      <Img src={url} alt="" loading="lazy" decoding="async" draggable={false} />
    ) : (
      <>
        <Icon name="user" size={Math.round(size * 0.55)} />
        {muted ? <Slash /> : null}
      </>
    )}
  </Frame>
);

export default MascotAvatar;
